<div id="sidebar" class="sidebar" *ngIf="isUserLoggedIn">
    <span>
        {{ getRole() }}
    </span>
    <ul>
        <li *ngFor="let element of navigation" [routerLink]="element.link">{{ element.text }}</li>
    </ul>
</div>
